import { render } from "./LongRedemptionForm.vue?vue&type=template&id=0a7424d5&scoped=true"
import script from "./LongRedemptionForm.vue?vue&type=script&lang=js"
export * from "./LongRedemptionForm.vue?vue&type=script&lang=js"

import "./LongRedemptionForm.vue?vue&type=style&index=0&id=0a7424d5&scoped=true&lang=css"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7424d5"]])

export default __exports__